import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('users', options)



// WEBPACK FOOTER //
// ./src/store/modules/users.store.js